import {ExtraButtons} from "../components/extra-buttons";
import {Header} from "../components/layout/header";
import {TableSearch} from "../components/table-search";
import React from "react";
import {useUpdateHeaderTitle, usePermission} from "../hooks";
import {EditDrawer, getColumns, useGetData, useManageItems} from "../pages-lib/product-sets";
import styled from "styled-components";
import { Table as AntTable } from "antd"
import {VisibilityProvider} from "../components/visibility-provider";
import {API_BASE_MEDIA_URL} from "../config";

export default function ProductSets() {
    const [createDrawerState, setCreateDrawerState] = React.useState(false)
    const [editDrawerState, setEditDrawerState] = React.useState(false)

    function onSuccessEdit() {
        setEditDrawerState(!editDrawerState)
    }

    function onSuccessCreate() {
        setCreateDrawerState(!createDrawerState)
    }

    const headerTitle = useUpdateHeaderTitle({
        items: [],
        defaultTitle: "0 Наборов",
        arrType: ["Набор", "Набора", "Наборов"],
    })

    const {
        dataItems,
        pagination,
        isLoading,
        handleTableChange,
        handleSearchTable,
        getFormattedItems,
        refetch: getItems,
        options
    } = useGetData()

    const { hasPermission } = usePermission()

    const {
        onCreate,
        onEditItem,
        onDelete,
        onSaveEdit,
        editData,
    } = useManageItems(getItems, onSuccessEdit, onSuccessCreate)

    const columns = getColumns(hasPermission("product-sets.edit") ? onEditItem : null, hasPermission("product-sets.delete") ? onDelete : null)

    return (
        <>
            <Header
                title={headerTitle}
                extra={
                    <ExtraButtons
                        onCreate={hasPermission("product-sets.create") ? () => setCreateDrawerState(true) : undefined}
                        // onFilter={() => setFilterDrawerState(!filterDrawerState)}
                        // onSort={() => setSortableDrawerState(!sortableDrawerState)}
                        titles={{ onCreate: "Добавить набор" }}
                    />
                }
            />

            <TableSearch handleSearch={handleSearchTable} placeholder={"Поиск по ID, названию или GUID"} />

            <StyledTable
                dataSource={getFormattedItems(dataItems)}
                columns={columns}
                loading={isLoading}
                pagination={pagination}
                onChange={handleTableChange}
            />

            {hasPermission("product-sets.create") && (
                <VisibilityProvider visible={createDrawerState}>
                    <EditDrawer
                        title={"Создание набора"}
                        state={createDrawerState}
                        onClose={() => setCreateDrawerState(false)}
                        onSave={onCreate}
                        categoryOptions={options.categoryOptions}
                        productCategoryOptions={options.productCategoryOptions}
                        badgeOptions={options.badgeOptions}
                        initialValues={null}
                    />
                </VisibilityProvider>
            )}

            {hasPermission("product-sets.edit") && (
                <VisibilityProvider visible={editDrawerState}>
                    <EditDrawer
                        title={"Редактирование набора"}
                        state={editDrawerState}
                        onClose={() => setEditDrawerState(false)}
                        onSave={onSaveEdit}
                        categoryOptions={options.categoryOptions}
                        productCategoryOptions={options.productCategoryOptions}
                        badgeOptions={options.badgeOptions}
                        initialValues={editData}
                    />
                </VisibilityProvider>
            )}
        </>

    )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
